import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import {
  getUserStatsObject,
  getUrlDetailsObj,
  getTabType,
  recordActivity
} from '../../../../services/commonService';

// Helper function to sanitize vertical and subgroup names for valid CSS selectors
const sanitizeStringForId = (str) => {
  return str.replace(/[^a-zA-Z0-9-_]/g, '-'); // Replaces invalid characters with hyphens
};

export default function KeyTechnologies({ techdata }) {
  const [tabData, setTabData] = useState({});
  const [activeTab, setActiveTab] = useState(null);
  const { accountId, accountName } = useParams();
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = {}
  pageParsedData.query_params.tab = 'technology';
  var tab_name = getTabType('technology') || "";

  const changeTab = (tab) => {
    let userStat = getUserStatsObject(
      tab_name,
      "key_technologies_tab_change",
      "Data: "+tab+", Page Source: "+accountName,
      window.location.href
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);
    setActiveTab(tab);
  }

  // Group data by 'Vertical' and 'Sub-Group'
  useEffect(() => {
    // Ensure data is an array
    if (Array.isArray(techdata)) {
      const groupedData = techdata.reduce((acc, { vertical, sub_group, technologies }) => {
        if (!acc[vertical]) {
          acc[vertical] = [];
        }
        acc[vertical].push({
          SubGroup: sub_group,
          Technologies: technologies.join(', ') // Join technologies as a comma-separated string
        });
        return acc;
      }, {});

      // Sort subgroups by the count of technologies in descending order
      Object.keys(groupedData).forEach(vertical => {
        groupedData[vertical].sort((a, b) => {
          return b.Technologies.split(',').length - a.Technologies.split(',').length;
        });
      });

      // Sort verticals by total technologies count (descending)
      const sortedVerticals = Object.keys(groupedData).sort((a, b) => {
        const totalA = groupedData[a].reduce((sum, { Technologies }) => sum + Technologies.split(',').length, 0);
        const totalB = groupedData[b].reduce((sum, { Technologies }) => sum + Technologies.split(',').length, 0);
        return totalB - totalA;
      });

      // Rebuild the groupedData object based on sorted verticals
      const sortedGroupedData = {};
      sortedVerticals.forEach(vertical => {
        sortedGroupedData[vertical] = groupedData[vertical];
      });

      setTabData(sortedGroupedData);

      // Set the first vertical as the default active tab
      const firstTab = sortedVerticals[0];
      setActiveTab(firstTab);
    } else {
      console.error("Invalid data format:", techdata);
    }
  }, [techdata]);

  // Function to calculate total technologies in a vertical
  const calculateTotalTechnologies = (vertical) => {
    const subGroups = tabData[vertical] || [];
    return subGroups.reduce((total, { Technologies }) => total + Technologies.split(',').length, 0);
  };

  return (
    <div className="d-flex align-items-start vertical_tab_conversation">
      <div className="TLScroll">
        <ul className="nav flex-column nav-pills me-3 vertical_tab_conversation_left" id="pills-tab" role="tablist">
          {Object.keys(tabData).map((vertical) => {
            const subGroups = tabData[vertical];
            const sanitizedVerticalId = sanitizeStringForId(vertical);
            const totalTechnologies = calculateTotalTechnologies(vertical);
            return (
              <li className="nav-item" role="presentation" key={sanitizedVerticalId}>
                <button
                  className={`nav-link ${activeTab === vertical ? 'active' : ''}`}
                  id={`pills-${sanitizedVerticalId}-tab`}
                  data-bs-toggle="pill"
                  data-bs-target={`#pills-${sanitizedVerticalId}`}
                  type="button"
                  role="tab"
                  aria-controls={`pills-${sanitizedVerticalId}`}
                  aria-selected={activeTab === vertical}
                  onClick={() => changeTab(vertical)}
                >
                  {vertical} <span className="number">({totalTechnologies})</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="tab-content w-100" id="pills-tabContent">
        {Object.keys(tabData).map((vertical) => {
            const subGroups = tabData[vertical];
            const sanitizedVerticalId = sanitizeStringForId(vertical);
            return (
              <div
                className={`tab-pane fade ${activeTab === vertical ? 'show active' : ''} custom_tab_pane`}
                id={`pills-${sanitizedVerticalId}`}
                role="tabpanel"
                aria-labelledby={`pills-${sanitizedVerticalId}-tab`}
                key={sanitizedVerticalId}
              >
                <div className="vertical_tab_conversation_right">
                  <div className="row">
                    {subGroups.map(({ SubGroup, Technologies }, index) => {
                      const techCount = Technologies.split(',').length;
 
                      // Determine the block type (positive or negative) based on the index
                      const blockClass = index % 2 === 0 ? 'positive_block' : 'negative_block';
 
                      return (
                        <div className="col-md-6" key={SubGroup}>
                          <div className={blockClass}>
                            <h5 className="head">
                              {SubGroup} <span className="number">({techCount})</span>
                            </h5>
                            <ul className="list_vertical_tab">
                              <li className="list_tabs">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                {Technologies}
                              </li>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
